import { useCallback, useMemo } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import NavigationTabs, {
  NavigationTab,
} from '@antimatterhq/ui/components/navigationTabs';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { WarehouseLocationsDropdown } from '@/components/dropdown';
import { PageHeader } from '@/components/pageHeader/PageHeader';
import { PageBody } from '@/components/pageBody/PageBody';
import { useInitializationCheck } from '@/hooks/initialization/useInitializationCheck';

const TABS: NavigationTab[] = [
  {
    id: 'notables',
    label: 'Notables',
  },
  {
    id: 'observables',
    label: 'Observables',
  },
  {
    id: 'health',
    label: 'Health',
  },
  {
    id: 'query',
    label: 'Query',
  },
];

export default function Explore() {
  const { initialized } = useInitializationCheck();
  const { enableQueryPage } = useFlags<FlagSet>();

  const navigate = useNavigate();
  const match = useMatch('/explore/:childPath/*');
  const activeTab = match?.params?.childPath || '';

  const setActiveTab = useCallback(
    (tab: string) => {
      navigate(`/explore/${tab}`);
    },
    [navigate],
  );

  const tabs = useMemo(() => {
    return enableQueryPage ? TABS : TABS.filter((tab) => tab.id !== 'query');
  }, [enableQueryPage]);

  if (!initialized) {
    return null;
  }

  return (
    <>
      <PageHeader pageTitle="Explore">
        <div className="flex h-9 items-center border-b border-gray-300">
          <div className="flex-grow">
            <NavigationTabs
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={setActiveTab}
              className="border-none"
            />
          </div>
          <WarehouseLocationsDropdown className="mb-auto" />
        </div>
      </PageHeader>
      <PageBody>
        <Outlet />
      </PageBody>
    </>
  );
}
